import request, { publicRequest } from '../../util/SuperagentUtils'
import type { Account } from '../../types/Account';
import {UserDetails} from "./interfaces";

// Session callers own expiry handling, including the persistent verification page.
export const isSessionExpired = (error: any): boolean => error?.status === 401;
export const isAuthenticatedAuthority = (account: Account | null | undefined): account is Account =>
    !!account?.id && !!account.loggedInUsername && account.username !== 'anonymousUser';
export const requestCurrentUsername = (
    onSuccess?: (currentUsername: string) => void,
    onFail?: (err: object) => void): void | Promise<any> => {

    const result = publicRequest
        .get('/api/current-username')
        .timeout({ response: 10000, deadline: 15000 })

    if(onSuccess && onFail) {
        result
            .then((resp: { text: string }) => onSuccess(resp.text))
            .catch((err: object) => onFail(err))
    } else {
        return result
    }
}

export const requestLoggedInUserDetails = (
    onSuccess?: (userDetails: UserDetails) => void,
    onFail?: (err: object) => void ): void | Promise<any> => {

    const result = request
        .get('/api/user-details')

    if(onSuccess && onFail) {
        result
            .then((resp: {body: any}) => onSuccess(resp.body))
            .catch((err: any) => onFail(err))
    } else {
        return result
    }
}

export function requestLoggedInAuthoritySource(
    onSuccess: (authority: object) => void,
    onFail: (err: object) => void
): void;
export function requestLoggedInAuthoritySource(): Promise<any>;
export function requestLoggedInAuthoritySource(
    onSuccess?: (authority: object) => void,
    onFail?: (err: object) => void
): void | Promise<any> {
    const result = publicRequest
        .get('/api/authority')
        .set('Cache-Control', 'no-cache')
        .timeout({ response: 10000, deadline: 15000 })

    if (onSuccess && onFail) {
        result
            .then((resp: {body: any}) => onSuccess(resp.body))
            .catch((err: any) => onFail(err))
    } else {
        return result
    }
}

export const requestLoggedInAccount = (onSuccess?: (account: object) => void,
                                onFail?: (err: object) => void): void | Promise<any> => {
    const result = request
        .get('/api/account')

    if(onSuccess && onFail) {
        result
            .then((resp: {body: any}) => onSuccess(resp.body))
            .catch((err: any) => onFail(err))
    } else {
        return result
    }
}

export const requestLogout = (onSuccess?: (resp: object) => void,
                              onFail?: (err: object) => void): void | Promise<any> => {
    const result = request
        .post('/api/logout')

    if(onSuccess && onFail) {
        result
            .then((resp: {body: any}) => onSuccess(resp))
            .catch((err: any) => onFail(err))
    } else {
        return result
    }
}
